import type { Tables } from '@/types/database';

type UserProfile = Tables<'user_profiles'>;

const SUPPORTED_KEYS = [
  'first_name',
  'last_name',
  'patronymic',
  'email',
  'phone',
  'city',
  'workplace',
] as const;

export type MeetingUrlVariable = typeof SUPPORTED_KEYS[number];

export function resolveMeetingUrl(
  url: string,
  profile: Pick<UserProfile, MeetingUrlVariable> | null | undefined,
): string {
  return url.replace(/\{\{(\w+)\}\}/g, (_, key: string) => {
    if (!profile || !SUPPORTED_KEYS.includes(key as MeetingUrlVariable)) return '';
    const value = profile[key as MeetingUrlVariable];
    return value ? encodeURIComponent(String(value)) : '';
  });
}
